import { httpClient, baseURL } from '@/utils/http-client';
import { computeTime } from '@/utils/common';
class SubtitlesService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    mapTimeStamp(sentence, raw) {
        return sentence.map((word) => {
            const _ = raw[word.index];
            let startTime_str = `${_.startTime.seconds ? _.startTime.seconds : '0'}.${_.startTime.nanos ? _.startTime.nanos : '0'}`;
            let endTime_str = `${_.endTime.seconds ? _.endTime.seconds : '0'}.${_.endTime.nanos ? _.endTime.nanos : '0'}`;
            const timestamp = {
                startTime: parseFloat(startTime_str),
                startTimeRaw: computeTime(_.startTime),
                endTime: parseFloat(endTime_str),
                endTimeRaw: computeTime(_.endTime)
            };
            return {
                ...word,
                timeStamp: timestamp
            };
        });
    }
    formatSubtitleObject(data) {
        const sentences = data.sentences;
        const raw = data.transcription;
        const result = sentences.map((sentence, index) => {
            return {
                index,
                words: this.mapTimeStamp(sentence, raw),
                selected: false,
                disableDrag: true
            };
        });
        return {
            grouped: result
        };
    }
    async getSubtitles(id) {
        const response = await this.httpClient.get(`/video/transcription/${id}`);
        const { data } = response;
        return data;
    }
    async downloadSubtitle(id) {
        const response = await this.httpClient.get(`/video/transcription/download/${id}`, {
            responseType: 'blob'
        });
        // Create a blob URL for the file data
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        return blobUrl;
    }
    async getTranscriptionBySentence(id) {
        return this.httpClient.get(`/video/transcription/sentences/${id}`);
    }
    async getTranscriptionByParagraphs(id) {
        return this.httpClient.get(`/video/transcription/paragraphs/${id}`);
    }
    async getTranscriptionStatus(id) {
        return new EventSource(`${baseURL}/events/transcribe/status/${id}`);
    }
}
export default SubtitlesService;
